import React from "react";
import contextProvider from "../../../contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";

import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import Panel from "../../../_L1_components/Layout/Panel";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";

class ProbeSetupSignalTHold extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
    };
    super(props, initState);
  }

  loadProbeSetup(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        if (this.props.onConfLoad) {
          this.props.onConfLoad();
        }
        this.apiStore.fire("get_probe_setup_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "signthold",
          },
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this._probe_setup_form.init({
                signthold: data,
              });
              this.setState({
                data: data,
                loading: false,
              });
            }
          },
        });
      }
    );
  }

  saveProbeSetup(data, cb) {
    //		console.log("DEBUG :: ProbeSetup _ saveProbeSetup");
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("set_probe_setup_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "signthold",
            value: data["signthold"],
          },
          ___onSuccess: (status, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                this.loadProbeSetup();
                if (cb) {
                  cb(status, data);
                }
              }
            );
          },
        });
      }
    );
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this.loadProbeSetup();
  }

  onComponentWillUnmount() {
    this.mounted = false;
  }

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <Panel
          className="mb-4 rounded-bottom"
          //	header="GENERAL SETTINGS"
          style={{
            minHeight: "100px",
          }}
        >
          <ReactOForm
            onSubmit={this.saveProbeSetup.bind(this)}
            unsavedWarning={true}
            onControllerReady={(form_controller) => {
              this._probe_setup_form = form_controller;
            }}
            preInit={(form_data) => {
              if (/^-/.test(form_data.signthold)) {
                form_data.signthold = form_data.signthold.toString().replace(/-/, "");
              } else {
                form_data.signthold = "";
              }
              return form_data;
            }}
            preSubmit={(form_data) => {
              if (form_data.signthold) {
                form_data.signthold = "-" + form_data.signthold;
              } else {
                form_data.signthold = "";
              }
              return form_data;
            }}
          >
            <Row className="mb-3">
              <Col xs={12} sm={6} lg={4}>
                <ReactOFormInput
                  type="text"
                  data_key="signthold"
                  label="Do not consider access point with RSSI worse than:"
                  placeholder="Signal threshold"
                  size="md"
                  default=""
                  prepend="-"
                  append="dBm"
                  validators={[
                    {
                      func: (value) => {
                        return (
                          (/^\d+$/.test(value) && parseInt(value) > 0) ||
                          value === undefined
                        );
                      },
                      invalid_text: "Type a valid RSSI value",
                    },
                  ]}
                />
              </Col>
            </Row>
            {!this.state.loading && (
              <div className="sub-title">
                <p>
                  This criterion applies to all the measures running on the probe.
                  <br />
                  Measures will not occur on AP BSSID with a radio signal worse than the
                  threshold.
                  <br />
                  You can further restrict the set of AP BSSID to measure, configuring the
                  "Connection Criteria" in the "Measure Setup / Advanced".
                </p>
              </div>
            )}
            <ReactOActionBar align="right" padding="0">
              <ReactOFormInput type="submit" value="Save" color="primary" icon="save">
                Save
              </ReactOFormInput>
            </ReactOActionBar>
          </ReactOForm>
        </Panel>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(
  withRouter(ProbeSetupSignalTHold),
  //	withDefinedContext(ProbeSetupSignalTHold, 'ProbeSetupSignalTHold', context_exposed_methods),
  {
    define: null,
  }
);
